import React from 'react';
import { Eye, X } from 'lucide-react';
interface PreviewBannerProps {
  forcedState?: 'coming-soon' | 'open' | 'closed' | null;
  onClose?: () => void;
}
export function PreviewBanner({
  forcedState,
  onClose
}: PreviewBannerProps) {
  return <div className="bg-yellow-500 text-yellow-900 px-4 py-3 relative" data-id="element-203">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-204">
        <div className="flex items-center space-x-3" data-id="element-205">
          <Eye className="h-5 w-5" data-id="element-206" />
          <div data-id="element-207">
            <span className="font-semibold" data-id="element-208">Preview Mode</span>
            {forcedState && <span className="ml-2 text-sm" data-id="element-209">
                (Forced state:{' '}
                <span className="font-medium" data-id="element-210">
                  {forcedState.replace('-', ' ')}
                </span>
                )
              </span>}
            <span className="ml-2 text-sm" data-id="element-211">
              - This is how customers will see the store
            </span>
          </div>
        </div>
        {onClose && <button onClick={onClose} className="p-1 hover:bg-yellow-600 rounded transition-colors" aria-label="Close preview" data-id="element-212">
            <X className="h-5 w-5" data-id="element-213" />
          </button>}
      </div>
    </div>;
}